<template>
  <el-row class="page-fitter">
    <el-select
      v-model="fitter.company_name.key"
      filterable
      remote
      reserve-keyword
      placeholder="请输入公司名称筛选公司"
      size="mini"
      clearable
      :remote-method="searchRemoteCompanyMethod"
      :loading="searchLoading"
      @change="handleSearchCompanyChange"
    >
      <el-option
        v-for="company in searchCompanies"
        :key="company"
        :label="company"
        :value="company"
      >
      </el-option>
    </el-select>
    <company-clue-fitter :fitter="fitter" @search="handleSearch" />
    <el-popover placement="bottom-start" v-model="searchVisible">
      <el-form :model="fitter" ref="searchForm" label-width="100px">
        <el-form-item label="产权分类" prop="select_key">
          <el-select style="width: 100%;" v-model="fitter.select_key" placeholder="请选择" size="mini" @change="resetForm('searchForm')">
            <el-option
              v-for="item in selectKeys"
              :key="item"
              :label="item"
              :value="item">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item v-show="fitter.select_key === '商标信息'" label="商标名称" prop="trademark_name.key">
          <el-input size="mini" v-model="fitter.trademark_name.key" placeholder="商标名称"></el-input>
        </el-form-item>
        <el-form-item v-show="fitter.select_key === '商标信息'" label="商标状态" prop="trademark_status.key">
          <el-select style="width: 100%;" v-model="fitter.trademark_status.key" @click.native="loadKeys('商标状态')" :loading="isLoadingTrademark" clearable placeholder="请选择" size="mini">
            <el-option
              v-for="item in trademarkStatus"
              :key="item"
              :label="item"
              :value="item">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item v-show="fitter.select_key === '商标信息'" label="国际分类" prop="trademark_type.key">
          <el-select style="width: 100%;" v-model="fitter.trademark_type.key" @click.native="loadKeys('国际分类')" :loading="isLoadingTrademarkType" multiple clearable placeholder="请选择" size="mini">
            <el-option
              v-for="item in trademarkTypes"
              :key="item"
              :label="item"
              :value="item">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item v-show="fitter.select_key === '商标信息'" label="申请日期" prop="apply_for_date.key">
          <el-date-picker
            v-model="fitter.apply_for_date.key"
            value-format="yyyy-MM-dd"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            size="mini"
          ></el-date-picker>
        </el-form-item>
        <el-form-item v-show="fitter.select_key === '商标信息'" label="注册公告日期" prop="bulletin_date.key">
          <el-date-picker
            v-model="fitter.bulletin_date.key"
            value-format="yyyy-MM-dd"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            size="mini"
          ></el-date-picker>
        </el-form-item>
        <el-form-item v-show="fitter.select_key === '专利信息'" label="申请号" prop="apply_for_num.key">
          <el-input size="mini" v-model="fitter.apply_for_num.key" placeholder="申请号"></el-input>
        </el-form-item>
        <el-form-item v-show="fitter.select_key === '专利信息'" label="发明名称" prop="invented_name.key">
          <el-input size="mini" v-model="fitter.invented_name.key" placeholder="发明名称"></el-input>
        </el-form-item>
        <el-form-item v-show="fitter.select_key === '专利信息'" label="专利类型" prop="patent.key">
          <el-select style="width: 100%;" v-model="fitter.patent.key" @click.native="loadKeys('专利类型')" :loading="isLoadingPatentTypes" multiple clearable placeholder="请选择" size="mini">
            <el-option
              v-for="item in patentTypes"
              :key="item"
              :label="item"
              :value="item">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item v-show="fitter.select_key === '专利信息'" label="法律状态" prop="law_status.key">
          <el-select style="width: 100%;" v-model="fitter.law_status.key" @click.native="loadKeys('法律状态')" :loading="isLoadingLawStatus" multiple clearable placeholder="请选择" size="mini">
            <el-option
              v-for="item in lawStatus"
              :key="item"
              :label="item"
              :value="item">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item v-show="fitter.select_key === '专利信息'" label="申请日" prop="apply_for_day.key">
          <el-date-picker
            v-model="fitter.apply_for_day.key"
            value-format="yyyy-MM-dd"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            size="mini"
          ></el-date-picker>
        </el-form-item>
        <el-form-item v-show="fitter.select_key === '软件著作权'" label="登记号" prop="registration_no.key">
          <el-input size="mini" v-model="fitter.registration_no.key" placeholder="登记号"></el-input>
        </el-form-item>
        <el-form-item v-show="fitter.select_key === '软件著作权'" label="软著名称" prop="app_name.key">
          <el-input size="mini" v-model="fitter.app_name.key" placeholder="软著名称"></el-input>
        </el-form-item>
        <el-form-item v-show="fitter.select_key === '软件著作权'" label="登记日期" prop="registration_date.key">
          <el-date-picker
            v-model="fitter.registration_date.key"
            value-format="yyyy-MM-dd"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            size="mini"
          ></el-date-picker>
        </el-form-item>
        <el-form-item v-show="fitter.select_key === '软件著作权'" label="权利取得方式" prop="acquisition_method.key">
          <el-select style="width: 100%;" v-model="fitter.acquisition_method.key" @click.native="loadKeys('权利取得方式')" :loading="isLoadingAcquisitionMethods" multiple clearable placeholder="请选择" size="mini">
            <el-option
              v-for="item in acquisitionMethods"
              :key="item"
              :label="item"
              :value="item">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item v-show="fitter.select_key === '备案网站'" label="公安备案号" prop="record_number.key">
          <el-input size="mini" v-model="fitter.record_number.key" placeholder="公安备案号"></el-input>
        </el-form-item>
        <el-form-item v-show="fitter.select_key === '备案网站'" label="网站备案号" prop="web_record_number.key">
          <el-input size="mini" v-model="fitter.web_record_number.key" placeholder="网站备案/许可证号"></el-input>
        </el-form-item>
        <el-form-item v-show="fitter.select_key === '备案网站'" label="域名" prop="domain.key">
          <el-input size="mini" v-model="fitter.domain.key" placeholder="域名"></el-input>
        </el-form-item>
        <el-form-item v-show="fitter.select_key === '备案网站'" label="审核日期" prop="examined_date.key">
          <el-date-picker
            v-model="fitter.examined_date.key"
            value-format="yyyy-MM-dd"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            size="mini"
          ></el-date-picker>
        </el-form-item>
        <el-form-item v-show="fitter.select_key === '备案网站'" label="网站类型" prop="web_types.key">
          <el-select style="width: 100%;" v-model="fitter.web_types.key" @click.native="loadKeys('网站类型')" :loading="isLoadingWebTypes" multiple clearable placeholder="请选择" size="mini">
            <el-option
              v-for="(item, index) in webTypes"
              v-if="item"
              :key="index"
              :label="item"
              :value="item">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item v-show="fitter.select_key === '标准信息'" label="标准号" prop="standard_no.key">
          <el-input size="mini" v-model="fitter.standard_no.key" placeholder="标准号"></el-input>
        </el-form-item>
        <el-form-item v-show="fitter.select_key === '标准信息'" label="起草单位" prop="drafting_unit.key">
          <el-input size="mini" v-model="fitter.drafting_unit.key" placeholder="起草单位"></el-input>
        </el-form-item>
        <el-form-item v-show="fitter.select_key === '标准信息'" label="发布日期" prop="release_date.key">
          <el-date-picker
            v-model="fitter.release_date.key"
            value-format="yyyy-MM-dd"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            size="mini"
          ></el-date-picker>
        </el-form-item>
        <el-form-item v-show="fitter.select_key === '标准信息'" label="状态" prop="standard_status.key">
          <el-select style="width: 100%;" v-model="fitter.standard_status.key" @click.native="loadKeys('状态')" :loading="isLoadingStandardStatus" multiple clearable placeholder="请选择" size="mini">
            <el-option
              v-for="(item, index) in standardStatus"
              v-if="item"
              :key="index"
              :label="item"
              :value="item">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button @click="handelClearSearch('searchForm')" size="mini">重置</el-button>
          <el-button type="primary" @click="submitForm('searchForm')" size="mini">查询</el-button>
        </el-form-item>
      </el-form>
      <el-button slot="reference" size="mini">知识产权信息筛选</el-button>
    </el-popover>
  </el-row>
</template>

<script>
import CompanyClueFitter from "../../company_risks/common/CompanyClueFitter"
export default {
  name: 'IntellectualPropertyFitter',
  components: { CompanyClueFitter },
  props: {
    fitter: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data () {
    return {
      searchLoading: false,
      searchCompanies: [],
      searchVisible: false,
      selectKeys: ['商标信息', '专利信息', '软件著作权', '备案网站', '标准信息'],
      isLoadingTrademark: false,
      trademarkStatus: [],
      trademarkTypes: [],
      isLoadingTrademarkType: false,
      patentTypes: [],
      isLoadingPatentTypes: false,
      lawStatus: [],
      isLoadingLawStatus: false,
      isLoadingAcquisitionMethods: false,
      acquisitionMethods: [],
      isLoadingWebTypes: false,
      webTypes: [],
      isLoadingStandardStatus: false,
      standardStatus: []
    }
  },
  methods: {
    searchRemoteCompanyMethod(query) {
      if (query !== "") {
        this.searchLoading = true
        setTimeout(() => {
          this.searchArrItemCompanys(query)
        }, 200);
      } else {
        this.searchCompanies = []
      }
    },
    searchArrItemCompanys(query) {
      this.$axios.get("/api/admin/upload_tasks/risks/companies?name=" + query + '&type=2', { loadingClose: true }).then((res) => {
        const { data } = res;
        if (data.code === 0) {
          this.searchCompanies = data.data.companies
          this.searchLoading = false
        }
      })
    },
    handleSearchCompanyChange(val) {
      this.$emit('search', this.fitter)
    },
    handelClearSearch (formName) {
      this.$refs[formName].resetFields()
      this.searchVisible = false
      this.$emit('search', false)
    },
    submitForm(formName) {
      this.searchVisible = false
      this.$emit('search', false)
    },
    resetForm (formName) {
    },
    handleSearch (search) {
      this.$emit('search', false)
    },
    loadKeys (key) {
      if (key === '商标状态') this.isLoadingTrademark = true
      if (key === '国际分类') this.isLoadingTrademarkType = true
      if (key === '专利类型') this.isLoadingPatentTypes = true
      if (key === '法律状态') this.isLoadingLawStatus = true
      if (key === '权利取得方式') this.isLoadingAcquisitionMethods = true
      if (key === '网站类型') this.isLoadingWebTypes = true
      if (key === '状态') this.isLoadingStandardStatus = true
      this.$axios.get('/api/admin/upload_tasks_info/keys?select_key=' + this.fitter.select_key + '&key=' + key, { loadingClose: true })
        .then((res) => {
          const { data } = res
          if (data.code === 0) {
            if (key === '商标状态') {
              this.trademarkStatus = data.data
              this.isLoadingTrademark = false
            } else if (key === '国际分类') {
              this.trademarkTypes = data.data
              this.isLoadingTrademarkType = false
            } else if (key === '专利类型') {
              this.patentTypes = data.data
              this.isLoadingPatentTypes = false
            } else if (key === '法律状态') {
              this.lawStatus = data.data
              this.isLoadingLawStatus = false
            } else if (key === '权利取得方式') {
              this.acquisitionMethods = data.data
              this.isLoadingAcquisitionMethods = false
            } else if (key === '网站类型') {
              this.webTypes = data.data
              this.isLoadingWebTypes = false
            } else if (key === '状态') {
              this.standardStatus = data.data
              this.isLoadingStandardStatus = false
            }
          }
        })
    }
  }
}
</script>

<style lang="stylus" scoped>
.page-fitter >>> .el-input {
  width: auto;
}
.el-form-item {
  margin: 0;
}
</style>



// WEBPACK FOOTER //
// src/pages/intellectual_property/common/IntellectualPropertyFitter.vue